<template>
  <div class="add-word">
    <a-form>
      <a-form-item
          label="叢書名稱"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <a-input placeholder="請輸入叢書名稱" v-model="para.name"></a-input>
      </a-form-item>
      <a-form-item
          label="叢書作者"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <a-input placeholder="請輸入叢書名稱" v-model="para.author"></a-input>
      </a-form-item>
      <a-form-item
          label="叢書来源"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <a-input placeholder="請輸入叢書名稱" v-model="para.source"></a-input>
      </a-form-item>
      <a-form-item
          label="叢書简介"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <a-input type="textarea" autosize placeholder="叢書简介" v-model="para.desc"></a-input>
      </a-form-item>
      <a-form-item
          label="叢書分類"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <a-select v-model="para.type">
          <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{ item.desc }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
          label="叢書封面"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
      >
        <a-upload
            name="avatar"
            :withCredentials="true"
            accept="image/*"
            :showUploadList="false"
            listType="picture-card"
            class="avatar-uploader"
            :customRequest="upPic"
        >
          <img v-if="imageUrl" style="width:100%;" :src="imageUrl" alt="avatar"/>
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上傳封面</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item
          label="下載鏈接(非必填)"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
      >
        <a-input placeholder="請輸入下載鏈接" v-model="para.link"></a-input>
      </a-form-item>
      <a-form-item
          label="權限設置"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <p style="color:#ff3657;font-size: 14px;">請設置每類用戶角色的叢書可閱百分比，最大為100，最小為0</p>
        <div class="vip-item">
          <span class="title">非會員：</span>
          <div v-for="(item,index) in noVipList" :key="index">
            <a-input :min="0" :max="100" type="number" :addon-before="item.userDesc" addon-after="%"
                     v-model="item.radio" style="width:200px;"/>
          </div>
        </div>
        <div class="vip-item">
          <span class="title">會員：</span>
          <div v-for="(item,index) in vipList" :key="index">
            <a-input :min="0" :max="100" type="number" :addon-before="item.vipDesc" addon-after="%"
                     v-model="item.radio" style="width:200px;"/>
          </div>
        </div>
      </a-form-item>

      <a-form-item
          label="叢書内容分類"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
      >
        <a-radio-group name="radioGroup" v-model="lectionType">
          <a-radio :value="1">上傳PDF</a-radio>
          <a-radio :value="2">上傳圖片</a-radio>
          <a-radio :value="3">上傳富文本</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item
          label="叢書內容"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
          required
          style="text-align: left"
      >
        <div v-if="lectionType!==3">
          <div style="margin-bottom:20px;" v-if="imgList.length">
            <a-button @click="clearImg">清理图片</a-button>
          </div>
          <vuedraggable class="wrapper" v-model="imgList" animation="300">
            <transition-group>
              <div v-for="(item,index) in imgList" :key="item.id" class="item">
                <img :src="item.path" alt="" class="big" @click="showBig(item.path)">
                <img src="../../assets/image/close.png" alt="" class="del" @click="delImg(index)">
              </div>
            </transition-group>
          </vuedraggable>
          <a-upload
              v-if="lectionType === 1"
              :withCredentials="true"
              :showUploadList="false"
              :disabled="upLoading"
              :customRequest="upPdf"
          >
            <div
                style="margin-bottom:20px;width:100px;text-align:center;height: 100px;border:1px solid #f1f1f1;border-radius: 4px;cursor:pointer;">
              <a-icon :type="upLoading?'loading':'plus'" style="margin-top:30px;"/>
              <div class="ant-upload-text">{{ upMsg }}</div>
            </div>
          </a-upload>
          <a-upload
              v-if="lectionType === 2"
              :withCredentials="true"
              accept="image/*"
              multiple
              :showUploadList="false"
              :disabled="upLoading"
              :customRequest="upPicAll"
          >
            <div
                style="margin-bottom:20px;width:100px;text-align:center;height: 100px;border:1px solid #f1f1f1;border-radius: 4px;cursor:pointer;">
              <a-icon :type="upLoading?'loading':'plus'" style="margin-top:30px;"/>
              <div class="ant-upload-text">選擇文件</div>
            </div>
          </a-upload>
        </div>
        <div v-show="lectionType===3">
          <div id="editor"></div>
          <a-button class="clear-or" @click="addOne">添加内容至列表</a-button>
          <a-button class="clear-or" @click="delAll">清空列表</a-button>
          <swiper class="swiper-container-box" ref="mySwiper" :options="swiperOptions">
            <swiper-slide v-for="(item,index) in detailList" :key="index">
              <a-button class="edit-one" size="small" @click="edit(item,index)" type="primary">编辑
              </a-button>
              <a-button class="del-one" size="small" @click="del(item,index)" type="primary">删除</a-button>
              <div class="html-box" v-html="item"></div>
            </swiper-slide>
          </swiper>
        </div>
      </a-form-item>
      <a-form-item
          label=" "
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 12 }"
      >
        <a-button class="sub" @click="sub" type="primary">提交</a-button>
      </a-form-item>
    </a-form>
    <a-modal
        title=""
        :visible="bigImgShow"
        :footer="null"
        :maskClosable="true"
        :mask="true"
        :keyboard="true"
        :width="1080"
        @cancel="hideBigImg"
        :closable="false"
    >
      <img style="max-width:1000px;display: block;margin:0 auto;" :src="bigImg" alt="">
    </a-modal>
  </div>
</template>
<script>
import vuedraggable from 'vuedraggable';

import {quillEditor} from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {Swiper, SwiperSlide, directive} from 'vue-awesome-swiper'

export default {
  directives: {
    swiper: directive
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },
  },
  data() {
    return {
      imageUrl: '',
      loading: false,
      bigImgShow: false,
      bigLoading: false,
      detailList:[],
      noVipList: [
        {radio: 0, userType: 1, userDesc: '遊客'},
        {radio: 0, userType: 2, userDesc: '註冊用戶'},
      ],
      vipList: [],
      bigImg: undefined,
      typeList: [],
      para: {
        name: '',
        type: '',
        desc: '',
        link: '',
        author: '',
        source: ''
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
        placeholder: '請在此處編輯叢書詳情'
      },
      detail: '',
      picId: '',
      editor: null,
      upLoading: false,
      lectionType: 1,
      upMsg: '選擇PDF文件',
      imgList: [],
      editIndex: 0,
      editDetail: false,
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        // Some Swiper option/callback...
      },
    }
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      const E = window.wangEditor
      this.editor = new E('#editor')
      this.editor.config.pasteFilterStyle = false
      this.editor.config.withCredentials = true
      this.editor.config.excludeMenus = [
        'fontName'
      ]
      this.editor.config.colors = [
        "#000000","#ffffff","#eeece0","#1c487f","#4d80bf","#c24f4a","#8baa4a","#7b5ba1","#46acc8","#f9963b","#f44336"
      ]
      this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
        console.log(resultFiles)
        // resultFiles 是 input 中选中的文件列表
        self.upPicDetail(resultFiles, insertImgFn)
      }
      this.editor.create()
    })
    this.getVip()
  },
  methods: {
    del(item, index) {
      this.detailList.splice(index, 1)
    },
    edit(item, index) {
      this.editIndex = index;
      this.editDetail = true;
      this.editor.txt.html(item)
    },
    delAll() {
      this.detailList.splice(0, this.detailList.length)
    },
    addOne() {
      let self = this;
      console.log(this.detailList[this.editIndex])
      if (this.editDetail) {
        // this.detailList[this.editIndex] = this.editor.txt.html();
        this.$set(this.detailList, this.editIndex, this.editor.txt.html())
        this.editDetail = false;
      } else {
        this.detailList.push(this.editor.txt.html())
        setTimeout(function () {
          self.swiper.slideTo(self.detailList.length - 1, 400, false)
        }, 200)
      }
      this.editor.txt.clear()
    },
    getVip() {
      let self = this;
      this.loading = true;
      return new Promise((resolve, reject) => {
        self.$http({
          method: 'post',
          url: '/manager/vip/list',
        }).then(function (res) {
          self.loading = false;
          let arr = []
          res.data.forEach(item => {
            arr.push({
              radio: 0,
              vipDesc: item.vipDesc,
              vipType: item.vipType
            })
          })
          arr.sort((a, b) => {
            return a.vipType - b.vipType;
          })
          self.vipList = arr;
          resolve()
        }).catch(err => {
          self.loading = false;
          self.$Message.error(JSON.stringify(err))
          resolve();
        })
      })
    },
    upPic(file) {
      let self = this;
      this.loading = true;
      let param = new FormData()
      param.append('files', file.file)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };
      this.$http.post('/manager/media/upload/pic', param, config)
          .then(response => {
            if (response.code === 20000) {
              self.imageUrl = response.data.mediaInfo[0].path;
              self.picId = response.data.mediaInfo[0].id;
              self.loading = false;
            } else {
              self.loading = false
            }

          }).catch(err => {
        console.log(err)
        self.loading = false;
      })
    },
    getList() {
      let self = this;
      return new Promise((resolve, reject) => {
        self.$http({
          method: 'get',
          url: '/manager/type/noun/list',
        }).then(function (res) {
          self.loading = false;
          if (res.data && res.data.length) {
            self.typeList = res.data;
          } else {
            self.typeList = []
          }
          resolve()
        }).catch(err => {
        })
      })

    },
    sub() {
      let self = this;
      let data = {}
      let flag = false;
      let detailFlag = false;
      if (this.para.name === '') {
        this.$Message.warning('請輸入名稱')
        return false;
      }
      if (this.para.author === '') {
        this.$Message.warning('請輸入作者')
        return false;
      }
      if (this.para.source === '') {
        this.$Message.warning('請輸入来源')
        return false;
      }
      if (this.para.desc === '') {
        this.$Message.warning('請輸入簡介')
        return false;
      }
      if (!this.para.type) {
        this.$Message.warning('請選擇分類')
        return false;
      }
      if (this.para.type * 1 === 5) {
        if (this.picId === '') {
          this.$Message.warning('請上傳封面')
          return false;
        }
      }
      this.noVipList.forEach(item => {
        if (!item.radio || item.radio === '') {
          this.$Message.warning(`${item.userDesc}百分比不能為空`);
          flag = true;
        }
        if (item.radio * 1 > 100) {
          this.$Message.warning(`${item.userDesc}的可觀看百分比不能超出100%`);
          flag = true;
        }
        if (item.radio * 1 < 0) {
          this.$Message.warning(`${item.userDesc}的可觀看百分比不能小於0`);
          flag = true;
        }
      })
      this.vipList.forEach(item => {
        if (!item.radio || item.radio === '') {
          this.$Message.warning(`${item.vipDesc}百分比不能為空`);
          flag = true;
        }
        if (item.radio * 1 > 100) {
          this.$Message.warning(`${item.vipDesc}的可觀看百分比不能超出100%`);
          flag = true;
        }
        if (item.radio * 1 < 0) {
          this.$Message.warning(`${item.vipDesc}的可觀看百分比不能小於0`);
          flag = true;
        }
      })
      if (flag) {
        return false;
      }
      if (this.para.link !== '') {
        data.downloadUrl = this.para.link
      }
      if (this.lectionType === 1) {
        if (this.imgList.length === 0) {
          this.$Message.warning('請上傳叢書PDF')
          detailFlag = true;
        }
      } else if (this.lectionType === 2) {
        if (this.imgList.length === 0) {
          this.$Message.warning('請上傳叢書圖片')
          detailFlag = true;
        }
      } else if (this.lectionType === 3) {
        if (!this.detailList.length) {
          this.$Message.warning('請輸入叢書內容')
          detailFlag = true;
        }
      }
      if (detailFlag) {
        return false;
      }
      data.title = this.para.name;
      data.nounTypeId = this.para.type;
      data.introduction = this.para.desc;
      data.source = this.para.source;
      data.author = this.para.author;
      data.lectionType = this.lectionType;
      let arr = []
      this.imgList.forEach((item, index) => {
        arr.push({id: item.id, sortNum: (index * 1) + 1})
      })
      if (this.lectionType === 3) {
        data.type = 0;
      } else {
        data.type = 1;
      }
      data.limits = []
      this.noVipList.forEach(item => {
        data.limits.push({
          radio: item.radio,
          userType: item.userType
        })
      })
      let obj = {
        userType: 3,
        vip: []
      }
      this.vipList.forEach(item => {
        obj.vip.push({
          radio: item.radio,
          vipType: item.vipType
        })
      })
      data.limits.push(obj)
      if (this.lectionType === 3) {
        data.lectionDesc = this.detailList;
      } else {
        data.picInfos = arr;
      }
      if (this.picId !== '') {
        data.picId = this.picId;
      }
      data.content = ''
      let url;
      if (this.$route.query.id) {
        url = '/manager/noun/update'
        data.id = this.$route.query.id;
      } else {
        url = '/manager/noun/add'
        delete data.id;
      }
      this.subLoading = true;
      this.$http({
        method: 'post',
        url: url,
        data: data
      }).then(function (res) {
        self.$Message.success('添加成功')
        self.$router.replace({name: 'wordList'})
        self.para.name = ''
        self.para.type = ''
        self.para.desc = ''
        self.detail = ''
        self.imageUrl = ''
        self.imgList = []
      }).catch(err => {
      })
    },
    setData() {
      let self = this;
      this.$http({
        method: 'get',
        url: '/manager/noun/detail',
        params: {
          nounId: self.$route.query.id
        }
      }).then(function (res) {
        self.para.name = res.data.title;
        self.para.type = res.data.nounTypeId;
        self.para.desc = res.data.introduction;
        self.para.source = res.data.source ? res.data.source : '';
        self.para.author = res.data.author ? res.data.author : '';
        self.lectionType = res.data.type === 0 || !res.data.type ? 3 : 2
        if (res.data.downloadUrl && res.data.downloadUrl !== '') {
          self.para.link = res.data.downloadUrl
        }
        if (res.data.picPath !== '') {
          self.imageUrl = res.data.picPath;
          self.picId = res.data.picId;
        }
        // if(res.data.type === 1){
        //   let imgList = [];
        //   let imgObj = JSON.parse(res.data.imgList)
        //   imgObj.forEach((item,index) => {
        //     imgList.push({path: item,id:index})
        //   })
        //   self.imgList = imgList
        // }
        if (res.data.lectionDesc && res.data.lectionDesc.length) {
          self.detailList = res.data.lectionDesc;
        } else {
          self.lectionType = 1
        }
        if (res.data.mediaPics && res.data.mediaPics.length) {
          res.data.mediaPics.forEach(item => {
            self.imgList.push({
              id: item.id,
              path: item.picPath
            })
          })
        }
        self.noVipList.forEach(item => {
          res.data.limits && res.data.limits.forEach(sub => {
            if (item.userType === sub.userType) {
              item.radio = sub.radio;
            }
          })
        })
        res.data.limits && res.data.limits.forEach(sub => {
          if (sub.userType === 3) {
            self.vipList = sub.vip;
          }
        })
        self.editor.txt.html(res.data.content)
        self.loading = false;
      }).catch(err => {
      })
    },
    async initData() {
      await this.getList();
      if (this.$route.query.id) {
        this.setData();
      }
    },
    clearImg() {
      this.imgList.splice(0, this.imgList.length)
    },
    upPicDetail(file, fn) {
      let self = this;
      this.$load.show();
      let param = new FormData()
      param.append('files', file[0])
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };
      this.$http.post('/manager/media/upload/pic', param, config)
          .then(response => {
            fn(response.data.mediaInfo[0].path)
            self.$load.hide();
          })
    },
    delImg(index) {
      this.imgList.splice(index, 1)
    },
    upPicAll(file) {
      let self = this;
      this.upLoading = true;
      let param = new FormData()
      param.append('files', file.file)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      };
      this.$http.post('/manager/media/upload/pic?isSy=1', param, config)
          .then(response => {
            self.imgList = self.imgList.concat(response.data.mediaInfo)
            self.upLoading = false;
          }).catch(err => {
            self.upLoading = false;
      })
    },
    upPdf(file) {
      let self = this;
      this.upLoading = true;
      let upTime = new Date().getTime();
      let param = new FormData()
      param.append('files', file.file)
      param.append('randNumber', upTime)
      console.log(upTime)
      let config = {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: function (progressEvent) { //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            let complete = (progressEvent.loaded / progressEvent.total * 100 | 0) + '%'
            self.upMsg = '上傳 ' + complete
            if (complete === '100%') {
              self.upMsg = '上傳完成，处理中'
              // let progress = setInterval(function () {
              //   self.$http.post('/manager/media/upload/pdf/index?randNumber=' + upTime)
              //       .then(response => {
              //         self.upMsg = '正在处理第' + response.data.currentPage + '/' + response.data.totalPages + '张'
              //         if (response.data.currentPage === response.data.totalPages || response.data.code === 20000) {
              //           clearInterval(progress)
              //           self.upMsg = '選擇PDF文件'
              //         }
              //       }).catch(err => {
              //   })
              // }, 1000)
            }
          }
        },
      };
      this.$http.post('/manager/media/upload/pdf', param, config)
          .then(response => {
            self.imgList = response.data.mediaInfo
            self.upLoading = false;
            self.upMsg = '選擇PDF文件'
          }).catch(err => {
              self.upLoading = false;
              self.upMsg = '選擇PDF文件'
            })
    },
    showBig(img) {
      this.bigImg = img;
      this.bigImgShow = true;
    },
    hideBigImg() {
      this.bigImgShow = false;
      this.bigImg = ''
    }
  },
  created() {
    this.initData();
    this.$emit('breadcrumbChange', ['叢書管理', '添加叢書'])

  },
  beforeDestroy() {
    this.editor.destroy()
    this.editor = null
  },
  components: {
    quillEditor,
    vuedraggable,
    vuedraggable,
    Swiper,
    SwiperSlide
  },
}
</script>
<style lang="less">
div.add-word {
  .swiper-container-box {
    width: 375px;
    height: 667px;
    border-radius: 10px;
    border: 1px solid #ccc;
    box-shadow: 4px 4px 5px #f1f1f1;
    overflow-x: hidden;
    position: fixed;
    right: 20px;
    bottom: 100px;
    background-color: #fff;
    z-index: 20000;

    .edit-one {
      font-size: 12px;
      position: absolute;
      top: 10px;
      right: 10px;

      span {
        font-size: 12px;
      }
    }

    .del-one {
      font-size: 12px;
      position: absolute;
      top: 40px;
      right: 10px;

      span {
        font-size: 12px;
      }
    }

    .html-box {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 20px;
    }
  }

  .item {
    width: 100px;
    height: 100px;
    position: relative;
    float: left;
    margin-right: 20px;
    margin-bottom: 20px;

    .big {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      object-fit: cover;
      cursor: move;
    }

    .del {
      width: 20px;
      position: absolute;
      right: -10px;
      top: -10px;
      z-index: 1;
    }
  }

  .ant-form-item-control {
    text-align: left;
  }

  .sub {
    width: 100%;
  }

  .ql-toolbar.ql-snow {
    border-bottom: none;
    padding-top: 14px;
    padding-bottom: 0;
  }

  .ql-snow .ql-editor img {
    display: inline-block;
  }

  .ql-snow .ql-picker.ql-size, .ql-snow .ql-picker.ql-header {
    border: 1px solid #f1f1f1;
    border-radius: 4px;
  }

  .ql-snow .ql-color-picker .ql-picker-label svg, .ql-snow .ql-icon-picker .ql-picker-label svg {
    right: 4px;
    top: -6px;
    position: relative;
  }

  .ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before, .ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before {
    content: attr(data-label);
    position: relative;
    top: -8px;
  }

  .quill-editor {
    height: 400px;
  }
}
</style>
